<template>
  <div class="vdo-view box">
    <div class="cover" v-if="lecture.type === 'YOUTUBE'">
      <!-- {{"YOUTUBE"}} -->
      <iframe width="100%" height="100%"
        :src="upperDisplay.url">
      </iframe>
    </div>
    <!-- <LectureVideo
      v-else-if="lecture.type === 'VDO'"
      :url="upperDisplay.url"
      :lecture="lecture"
      :upperDisplay="upperDisplay"
    /> -->
    <div v-else-if="lecture.type === 'VDO'">
    <LectureVideo
      :url="upperDisplay.url"
      :lecture="lecture"
      :upperDisplay="upperDisplay"
    />
    </div>
    <div class="cover" v-else>
      <img
        :src="courseImage"
        alt
        srcset
      />
    </div>
  </div>
</template>
<script>
import LectureVideo from "./DisplayLectureByType/Video.vue";

export default {
  name: "LectureList",
  components: {
    LectureVideo
  },
  computed: {
    upperDisplay() {
      return this.$store.getters.upperDisplay?.fetchData;
    },
    courseImage() {
      return this.$store.getters.courseImage;
    },
    lecture() {
      // console.log(this.$store.getters.upperDisplay
      //   ? this.$store.getters.upperDisplay.lecture
      //   : {})
      return this.$store.getters.upperDisplay
        ? this.$store.getters.upperDisplay.lecture
        : {};
    }
  }
};
</script>